import React, { useState, useEffect } from 'react';
import { _T } from '../../shared/theme';
import { getInitials } from '../../shared/utils';

function Avatar({user,size=36,onClick,profileImage}) {
  const u = typeof user==="string" ? {name:user,color:_T.accent} : user;
  // Check localStorage for a profile image for this user
  const [img, setImg] = useState(null);
  useEffect(() => {
    if (profileImage) { setImg(profileImage); return; }
    try {
      // 1. Uploaded avatar stored locally
      const stored = localStorage.getItem(`sl_avatar_${u.id||u.name}`);
      if (stored) { setImg(stored); return; }
      // 2. Google/server picture on the user object itself
      if (u.picture) { setImg(u.picture); return; }
      // 3. For the current user: fall back to stored Google picture
      const currentUid = localStorage.getItem('sl_user_id');
      if (u.id === currentUid || u.id === 'me') {
        const gPic = localStorage.getItem('sl_google_picture');
        if (gPic) setImg(gPic);
      }
    } catch {}
  }, [u.id, u.name, u.picture, profileImage]);

  if (img) {
    return (
      <div onClick={onClick} style={{width:size,height:size,borderRadius:"50%",border:`2px solid ${u.isAI?_T.accent:u.color}55`,overflow:"hidden",cursor:onClick?"pointer":"default",flexShrink:0,background:_T.bg4}}>
        <img src={img} alt={u.name} style={{width:"100%",height:"100%",objectFit:"cover"}}/>
      </div>
    );
  }
  return (
    <div onClick={onClick} style={{width:size,height:size,borderRadius:"50%",background:u.isAI?`linear-gradient(135deg,${_T.grad1},${_T.grad2})`:`${u.color}25`,border:`2px solid ${u.isAI?_T.accent:u.color}55`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:u.isAI?size*0.4:size*0.35,fontWeight:700,color:u.isAI?"#0a1220":u.color,cursor:onClick?"pointer":"default",flexShrink:0}}>
      {u.isAI?"🤖":getInitials(u.name)}
    </div>
  );
}

export default Avatar;
